import React from 'react'

const SaintsList = () => (
    <div>
        <h1>Saints</h1>
    </div>
)

export default SaintsList